import Vue from 'vue'
import moment from 'moment-timezone'

const Plugin = {}

const plugin = Plugin.install = function (Vue, options) {
  Vue.prototype.$moment = moment
  moment.tz.setDefault('America/Chicago')

  moment.updateLocale('en', {
    monthsShort: [
      'Jan.', 'Feb.', 'Mar.', 'Apr.', 'May', 'June', 'July', 'Aug.', 'Sept.', 'Oct.', 'Nov.', 'Dec.'
    ],
    meridiem (hour, minute, isLowercase) {
      let meridiem = (hour < 12) ? 'a.m.' : 'p.m.'
      return (isLowercase) ? meridiem : meridiem.toUpperCase()
    },
    noon (hour, minute) {
      if (hour === 12 && minute === 0) {
        return 'Noon'
      }
    }
  })
}

Vue.use(plugin)
